import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollTracking = () => {
  const location = useLocation();
  const maxScrollRef = useRef(0);
  const sentMilestonesRef = useRef(new Set());

  useEffect(() => {
    maxScrollRef.current = 0;
    sentMilestonesRef.current = new Set();

    const milestones = [25, 50, 75, 100];

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;

      const scrollPercent = Math.round((scrollTop / docHeight) * 100);
      maxScrollRef.current = Math.max(maxScrollRef.current, scrollPercent);

      milestones.forEach((milestone) => {
        if (maxScrollRef.current >= milestone && !sentMilestonesRef.current.has(milestone)) {
          sentMilestonesRef.current.add(milestone);
          if (window.gtag) {
            window.gtag('event', 'scroll_depth', {
              page_path: location.pathname,
              percent_scrolled: milestone,
            });
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);
};

export default useScrollTracking;
